import bankruptcy from "./bankruptcy.jpeg";
import bonus from "./bonus.jpeg";
import chex from "./chex.jpeg";
import debt from "./debt.jpeg";
import deletion from "./deletion.jpeg";
import expectations from "./expectations.jpeg";
import reverse from "./reverse.jpeg";
import twoweeks from "./twoweeks.jpeg";
import zoning from "./zoning.jpeg";
import turo from "./turo.jpeg";
import unionlist from "./unionlist.png";
import tarik from "./tarik.jpeg";
import lendinglist from "./lendinglist.png";
import secrets from "./secrets.jpeg";
import logo from "./logo.png";

export const data = [
  {
    img: bankruptcy,
    title: "Bankruptcy Removal",
    desc: "Leverage these documents to accelerate Bankruptcy Removals. Download the resources provided in this module for your reference.",
    link: "/bankruptcyremoval",
  },
  {
    img: bonus,
    title: "**BONUS (Don't Pay For Student Loans)",
    desc: " 100+ ways to get rid of your student loans without paying for them. Download the resource provided to begin.",
    link: "/bonus",
  },
  {
    img: chex,
    title: "Chex Systems",
    desc: "Download all the resources listed in this module. As always, these resources can be found here as well:",
    link: "/chexsystem",
  },
  {
    img: debt,
    title: "Debt Validation",
    desc: "This letter is a template that you can use to request a validation of debt from the consumer reporting agencies!",
    link: "/debtvalidation",
  },
  {
    img: deletion,
    title: "Pay for Deletion",
    desc: "Here is a letter template to use for offering a payment for deletion to the collection company holding the debt.",
    link: "/payfordeletion",
  },
  {
    img: expectations,
    title: "Expectations for Credit Repair",
    desc: "This letter is a template you can use to set the correct expectations with clients for credit repair services. Access this document via Google Doc's here:",
    link: "/creditrepairexpectations",
  },
  {
    img: reverse,
    title: "Reverse Late Payments",
    desc: "Gain Access to the information on this topic by downloading. ",
    link: "/reverselatepayment",
  },
  {
    img: twoweeks,
    title: "2 Week Method",
    desc: " 14-Day Credit Deletion Method",
    link: "/twoweeksmethod",
  },
  {
    img: tarik,
    title: "Real Estate with Tarik",
    desc: "View Presentation Here!",
    link: "/tarik",
  },
  {
    img: zoning,
    title: "Zoning Guide (Philadelphia)-Paulette Ahmad",
    desc: "",
    link: "/zoning",
  },
  {
    img: turo,
    title: "How to get cars to put on TURO",
    desc: "",
    link: "/turo",
  },
  {
    img: unionlist,
    title: "Bella Sloan Secret Credit Union List",
    desc: "",
    link: "/unionlist",
  },
  {
    img: lendinglist,
    title: "Bella Sloan Secret Lending List",
    desc: "Big 3- Lenders List",
    link: "/lendinglist",
  },
  {
    img: secrets,
    title: "Credit Card Secrets (BONUS)",
    desc: "What lenders pull from which credit bureaus? Become familiar with who pulls from which bureaus.",
    link: "/secrets",
  },
  {
    img: logo,
    title: "How to Start an AirBNB",
    desc: "Turn Properties into Profit with Airbnb! 🏡💵 Join Kerry Chappelle as he teaches the essentials of launching your first Airbnb.",
    link: "/airbnb",
  },
  {
    img: logo,
    title: "How to Purchase Land for Under $1,000",
    desc: "Land Ownership Made Affordable! 🌄💸 Join Charles Noonan as he shares the secrets to purchasing land for under $1,000.",
    link: "/purchaseland",
  },
  {
    img: logo,
    title: "How to Get Removed From Chex System",
    desc: "Break Free from ChexSystems! 🚫💳 Join Regine Mazile as she shares expert insights on removing yourself from ChexSystems and getting back into the banking system.",
    link: "/removechex",
  },
  {
    img: logo,
    title: "Inquiry Removal",
    desc: "Say Goodbye to Hard Inquiries! 📝❌ Join Quashawn White as he reveals the methods for removing inquiries from your credit report the right way. Learn why clearing unnecessary inquiries can boost your score and increase your chances of getting approved for funding. It’s time to clean up your credit and unlock new possibilities! 💳🚀 #InquiryRemoval",
    link: "/inquiryremoval",
  },
  {
    img: logo,
    title: "How to Delete Bankruptcy",
    desc: " Overcoming Bankruptcy: Rebuild and Rise Again! 📈💪 In this powerful session with Joshua Rico, we’re tackling the steps to bounce back from bankruptcy.",
    link: "/deletebankruptcy",
  },
  {
    img: logo,
    title: "How to Delete Collection Removal",
    desc: "Take Charge of Your Credit! 🧾💥 Join our expert guest Regine Mazile as she walks us through effective strategies to delete collections from your credit report.",
    link: "/deletecollection",
  },
];
